import React from "react"
import { BasicTableSeeker } from "@ui-seeker/core"
import { dsColorNew } from "@palette"

import AppBasicTableLegend from "./Legend"
import AppTitleWithPopup from "../TitleWithPopup"


export default function AppBasicTable(
	{
		data = [],
		title = '',
		titleProps = {},
		headers = [],
		columns = [],
		Components = {},
		legend,
		...props
	}) {

	const conditionalProps = {
		...legend && { footer: <AppBasicTableLegend items={legend}/> }
	}

	return <BasicTableSeeker
		toolbarProps={{ actions: false }}
		data={data}
		title={Components?.Title ? <Components.Title title={title}/> :
			<AppTitleWithPopup title={title} {...titleProps} />}
		headers={headers}
		setHeaderRowsProps={() => ({
			sx: {
				backgroundColor: dsColorNew.tableHead,
			}
		})}
		setHeaderCellProps={() => ({
			sx: {
				backgroundColor: dsColorNew.tableHead,
			}
		})}
		setBodyRowsProps={(rowData, idx) => {
			return {
				sx: {
					backgroundColor: idx % 2 === 0 ? dsColorNew.white : dsColorNew.tableRowAlt,
					'&:hover': { backgroundColor: dsColorNew.hoverBgLight },
				}
			}
		}}
		columns={columns}
		{...conditionalProps}
		{...props}
	/>
}